import { useMutation, useQueryClient } from 'react-query';
import { getUseAdvisoryReportQKey } from '../../../../api/getAdvisoryReport';
import { AdvisoryReport } from '../../../../types/AdvisoryReport';
import { deleteInsurancePolicyById } from './deleteInsurance';

interface Params {
  reportId: string;
  insuranceId: string;
  packageId: string;
}

export const useDeletePackageInsurancePolicy = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ packageId, ...params }: Params) => deleteInsurancePolicyById(params),
    {
      onMutate: async ({ insuranceId, reportId, packageId }) => {
        const qKey = getUseAdvisoryReportQKey(reportId);
        await queryClient.cancelQueries(qKey);

        const previousReport = queryClient.getQueryData<AdvisoryReport>(qKey);
        if (previousReport) {
          const newPackages = previousReport.policy_packages?.map((pack) => {
            if (pack.id === packageId) {
              return {
                ...pack,
                insurance_policies: pack.insurance_policies.filter(
                  ({ id }) => id !== insuranceId,
                ),
              };
            }
            return pack;
          });

          queryClient.setQueryData(qKey, {
            ...previousReport,
            policy_packages: newPackages,
          });
        }
        return { qKey, previousReport };
      },
      onError: (_, __, context) => {
        if (context?.previousReport) {
          queryClient.setQueryData(context.qKey, context.previousReport);
        }
      },
    },
  );
};
